<!-- Banners -->
<div *ngFor="let view of visibleBanners; trackBy: trackByTriggerKey"
     class="as-banner"
     [ngClass]="getBannerClass(view.banner.color)">

  <!-- Left: icon + text -->
  <div class="as-banner__left">
    <!-- warning icon -->
    <svg *ngIf="view.banner.color === 'danger'" class="as-banner__icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.346 0-2.19-1.458-1.516-2.625L8.485 2.495ZM10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 6Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"/>
    </svg>
    <svg *ngIf="view.banner.color !== 'danger'" class="as-banner__icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z"/>
    </svg>

    <div class="as-banner__text">
      <span class="as-banner__message">{{ view.message }}</span>
      <span class="as-banner__sub" *ngIf="view.banner.sub_message">{{ view.banner.sub_message }}</span>
    </div>
  </div>

  <!-- Right: CTAs + dismiss -->
  <div class="as-banner__right">
    <div class="as-banner__actions" *ngIf="view.ctas.length">
      <a *ngFor="let cta of view.ctas; trackBy: trackByLabel"
              class="as-banner__btn"
              [class.as-banner__btn--outline]="cta.label === 'Transfer Event'"
              [routerLink]="cta.route"
              [queryParams]="cta.queryParams">
        {{ cta.label }}
      </a>
    </div>
    <button type="button" *ngIf="view.banner.is_dismissible" class="as-banner__close" (click)="dismiss(view.banner.trigger_key)" aria-label="Dismiss">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6 6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

</div>
